export default "__VITE_ASSET__CviLSjSp__"